import { jsx as _jsx } from "react/jsx-runtime";
import { kebabCase } from 'lodash';
import { TeleScript, getTelescriptItem } from '../../index';
var getConfigForComponent = function (componentName, config) {
    var _a, _b, _c, _d, _e, _f, _g;
    var telescriptItem = getTelescriptItem(componentName);
    return {
        id: componentName,
        hash: kebabCase(componentName),
        enabled: (_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.web) === null || _a === void 0 ? void 0 : _a.features) === null || _b === void 0 ? void 0 : _b[componentName]) !== null && _c !== void 0 ? _c : false,
        config: (_f = (_e = (_d = config === null || config === void 0 ? void 0 : config.site) === null || _d === void 0 ? void 0 : _d.components) === null || _e === void 0 ? void 0 : _e[componentName]) !== null && _f !== void 0 ? _f : null,
        telescript: getTelescriptItem(componentName),
        errorBoundaryFallback: _jsx(TeleScript, { line: (_g = telescriptItem === null || telescriptItem === void 0 ? void 0 : telescriptItem.fallback) !== null && _g !== void 0 ? _g : '', children: undefined }),
    };
};
export default getConfigForComponent;
